import logo from '@/assets/images/guido_bot.png'
import styles from './styles.module.css'
import {
    useCallback,
    // useEffect
} from 'react'
import { AppEvents, appEvents } from '@/core/events'
// import {
//     // PaidElements,
//     // SubscriptionStatus,
//     // SubscriptionType,
// } from '@/modules/subscribe/typing/enums'
// import { useAccountStore } from '@/store'

export const GuidoBot = () => {
    // const { account } = useAccountStore()

    // const type = account?.subscription?.type
    // const status = account?.subscription?.status
    // const isBasicFull =
    //     (type == SubscriptionType.Basic &&
    //         status !== SubscriptionStatus.Trial) ||
    //     (type == SubscriptionType.Basic_3m &&
    //         status !== SubscriptionStatus.Trial)

    // const openPopUpSubscribe = () => {
    //     appEvents.emit('paidElements', { type: PaidElements.Maskot })
    // }

    const eventBot = (): keyof AppEvents => {
        // switch (true) {
        // case status === SubscriptionStatus.Trial:
        //     return 'faqs'
        // case status === SubscriptionStatus.Active:
        //     return 'guidoBot'
        // case status === SubscriptionStatus.Unpaid:
        //     return 'subsribe'

        return 'guidoBot'
        // }
    }

    const openGuidoBot = useCallback(() => {
        appEvents.emit(eventBot(), { isShow: true, isUpdate: true })
    }, [])

    // useEffect(() => {
    //     if (status === SubscriptionStatus.Trial) {
    //         const interval = setInterval(
    //             () => openPopUpSubscribe(),
    //             5 * 60 * 1000,
    //         )
    //         return () => clearInterval(interval)
    //     }
    // }, [status])

    // if (isBasicFull) return null
    return (
        <div className={styles.container} onClick={openGuidoBot} id={'travy'}>
            <img src={logo} className={styles.guido_logo} />
        </div>
    )
}
